import {SyncIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import type {CopilotChatMode} from '../utils/copilot-chat-types'

export interface RetryButtonProps {
  handleRetryMessage: () => void
  mode: CopilotChatMode
}

export function RetryButton(props: RetryButtonProps) {
  const handleClick = () => {
    props.handleRetryMessage()
  }

  return (
    <IconButton
      variant="invisible"
      aria-label="Retry"
      data-testid="retry-button"
      onClick={handleClick}
      icon={SyncIcon}
    />
  )
}

try{ RetryButton.displayName ||= 'RetryButton' } catch {}